import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import * as toastr from 'toastr';
import {LayerModel} from '../../../../models/LayerModel';
import {Sl2AnagrafService} from '../../../general-services/service-sl2-anagraf/sl2-anagraf.service';

@Component({
  selector: 'app-edit-layer-anagraf',
  templateUrl: './edit-sl2-anagraf.component.html',
  styleUrls: ['./edit-sl2-anagraf.component.scss']
})
export class EditSl2AnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  layer: LayerModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;
  layerJson: any;

  saveSubscribe: Subscription;
  parameterSubscribe: Subscription;

  id: number;
  layerCod: string;
  description: any;
  submitted: boolean;

  constructor(private route: ActivatedRoute, private router: Router,
              private sl2AnagrafService: Sl2AnagrafService, private _Activatedroute: ActivatedRoute) {
    super();

    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.layerJson = params['row'];
      });

    this.layer = new LayerModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [{value: '', disabled: false}, Validators.required],
      description: [{value: '', disabled: false}, Validators.required]
    });

    this.layer = JSON.parse(this.layerJson) as LayerModel;

    this.formValidator.patchValue({
      cod: this.layer ? this.layer.cod : ''
    });

    this.formValidator.patchValue({
      description: this.layer ? this.layer.description : ''
    });

    _Activatedroute.params.subscribe(params => {
      this.id = params['id'];
      this.layerCod = params['cod'];
      this.description = params['description'];
    });
  }

  ngOnInit() {
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SL2_ANAGRF]);
  }

  edit() {
    this.submitted = true;
    if (this.formValidator.valid) {
      this.layer.cod = this.formValidator.controls['cod'].value;
      this.layer.description = this.formValidator.controls['description'].value;
      this.saveSubscribe = this.sl2AnagrafService.update(this.sl2AnagrafService.baseUrl, this.layer).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Layer Cod already exists', 'Warning');
          } else if (result === -2) {
            toastr.options.timeout = 5000;
            toastr.warning('Element already used', 'Warning');
          } else {
            toastr.success('Region with id ' + this.id + ' was added with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SL2_ANAGRF]);
          }
        }, error => {
          toastr.error('Element has not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

}
